// biome-ignore lint/performance/noNamespaceImport: library designed for namespace import
import * as Checkbox from '@radix-ui/react-checkbox';
import { tv, type VariantProps } from 'tailwind-variants';
import { Icon } from '@/app_components/common/Icon';
import { cn } from '@/app_lib/utils/utils';

const checkboxVariants = tv({
  slots: {
    hoverIcon:
      'hidden group-hover/checkbox:flex items-center justify-center w-full h-full group-[&[data-state=checked]]/checkbox:hidden group-[&[data-state=indeterminate]]/checkbox:hidden',
    indicator: 'flex items-center justify-center w-full h-full',
    label: 'flex gap-sm items-start cursor-pointer w-fit',
    root: 'group/checkbox border rounded-xs w-4 [&[data-state=checked]]:icon-white h-4 shrink-0 cursor-pointer',
  },
  variants: {
    variant: {
      conferences: {
        hoverIcon: 'text-[#616CFF]',
        root: 'size-4.5 m-[3px] border-2 rounded-sm [&[data-state=checked]]:bg-blue-1 [&[data-state=indeterminate]]:bg-blue-1 hover:bg-[#E7E9FF] [&[data-state=checked]]:border-blue-1 [&[data-state=indeterminate]]:border-blue-1 [&[data-state=indeterminate]]:icon-white',
      },
      default: {
        root: '[&[data-state=checked]]:bg-accent hover:bg-blue-100 [&[data-state=checked]]:stroke-accent',
      },
    },
  },
});

type CheckboxVariants = VariantProps<typeof checkboxVariants>;

export const CheckboxV2 = ({
  id,
  onClick,
  className = '',
  onChange,
  initialState = false,
  label,
  checked,
  variant = 'default',
}: {
  id: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  onChange: (val: boolean | 'indeterminate') => void;
  initialState?: boolean;
  label: string | React.ReactNode;
  checked: boolean | 'indeterminate' | undefined;
} & CheckboxVariants) => (
  <label
    className={checkboxVariants({ variant }).label()}
    htmlFor={id}
  >
    <Checkbox.Root
      checked={checked}
      className={cn(checkboxVariants({ variant }).root(), className)}
      defaultChecked={initialState}
      id={id}
      onCheckedChange={(val) => onChange(val)}
      onClick={onClick}
    >
      <span className={checkboxVariants({ variant }).hoverIcon()}>
        <Icon
          className='w-3 h-3'
          icon={checked === 'indeterminate' ? 'Minus' : 'Check'}
          size='lg'
          strokeWidth={3}
        />
      </span>
      <Checkbox.Indicator className={checkboxVariants({ variant }).indicator()}>
        <Icon
          className='w-3 h-3'
          icon={checked === 'indeterminate' ? 'Minus' : 'Check'}
          size='lg'
          strokeWidth={3}
        />
      </Checkbox.Indicator>
    </Checkbox.Root>
    {typeof label === 'string' ? <span>{label}</span> : label}
  </label>
);
